import * as React from 'react';
import CtaLink from '../CtaLink/CtaLink';
import LinkButton from '../LinkButton/LinkButton';
import S from './SectionHeader.styles';
const SectionHeader = ({ title, subtitle, content, sectionCta }) => {
    if (!title && !subtitle && !content) {
        return null;
    }
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        subtitle && React.createElement(S.Subtitle, null, subtitle),
        content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
        sectionCta && (React.createElement(React.Fragment, null, sectionCta.style && sectionCta.style === 'link' ? (React.createElement(CtaLink, { href: sectionCta.url, target: sectionCta.target }, sectionCta.text)) : (React.createElement(LinkButton, { buttonType: "default", href: sectionCta.url, target: sectionCta.target }, sectionCta.text))))));
};
export default SectionHeader;
